function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import map from 'lodash/map';
import filter from 'lodash/filter';
import includes from 'lodash/includes';
import Multiselect from 'vue-multiselect';
import 'vue-multiselect/dist/vue-multiselect.min.css';
import NcsSelect from './NcsSelect';
export default {
  "extends": NcsSelect,
  components: {
    Multiselect: Multiselect
  },
  props: {
    operator: {
      type: String,
      "default": 'eq_any'
    },
    searchable: {
      type: Boolean,
      "default": false
    }
  },
  computed: {
    values: function values() {
      return this.$store.getters['filters/possibleValues'](this.id);
    },
    selected: {
      get: function get() {
        var values = this.$store.getters['filters/selectedValue'](this.id);
        return filter(this.options, function (o) {
          return includes(values, o.value);
        });
      },
      set: function set(v) {
        this.$store.commit('filters/setFilter', _defineProperty({}, this.id, map(v, 'value')));
      }
    }
  },
  methods: {
    i18nOption: function i18nOption(option) {
      return option.label;
    }
  }
};